import { Controller } from "@hotwired/stimulus"

// This controller is used to move lead(s) to another leads list.
export default class extends Controller {
  static get targets() {
    return ["toggle"]
  }

  static get values() {
    return { url: String }
  }

  // This action opens the modal to select the leads list to move the lead(s) to. The content of the modal is loaded
  // using the result of a submit of a temporary form.
  toggle() {
    let url = new URL(this.urlValue, window.location.href)
    url.searchParams.set("organize_by_folder", this.toggleTarget.checked ? "1" : "0")

    Turbo.visit(url, { frame: "_top" })
  }
}
